/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import * as Roles from '../../../constants/role';
import { getVeiculosOptions } from '../../../store/veiculo/reducer';
import {
  DialogDefaultV2,
  InputV2,
  NsirSelectV2,
  OptionSelectV2,
  UsuarioSelectV2,
  VeiculoSelectV2,
} from '../../../components/v2';
import {
  TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO,
  TIPO_PROGRAMACAO_DIARIA_INSPECAO,
  TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS,
} from '../../../constants/ids';
import { buildRequiredSchema } from 'utils';

const getItemSchema = data => {
  const schema = buildRequiredSchema(['tipoId']);
  if (TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === data.tipoId) {
    return { ...schema, ...buildRequiredSchema(['cidadeDe', 'cidadePara']) };
  }
  if (TIPO_PROGRAMACAO_DIARIA_INSPECAO === data.tipoId) {
    return { ...schema, ...buildRequiredSchema(['nsirIds', 'descricao']) };
  }
  if (TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === data.tipoId) {
    return { ...schema, ...buildRequiredSchema(['veiculoId']) };
  }
  return schema;
};

const emptyItem = () => ({});

const ItemFormulario = ({ open, selectedItem, onClose, onSave, veiculosOptions }) => {
  const [values, setValues] = useState(emptyItem());
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setValues(selectedItem ? { ...selectedItem } : emptyItem());
      setErrors({});
    }
  }, [open, selectedItem]);

  const handleClose = () => {
    setErrors({});
    setValues(emptyItem());
    onClose();
  };

  const handleChange = event => setValues({ ...values, [event.target.name]: event.target.value });

  const handleTipoSelect = (tipoId, tipoNome) => {
    setValues({
      ...values,
      tipoId,
      tipo: tipoNome || values.tipo,
      cidadeDe: undefined,
      cidadePara: undefined,
      nsirIds: undefined,
      nsirCodes: undefined,
      veiculoId: undefined,
      veiculo: undefined,
    });
  };

  const handleVeiculoSelect = veiculoId => {
    const option = (veiculosOptions || []).find(v => v.id === veiculoId);
    setValues({
      ...values,
      veiculoId,
      veiculo: option?.placa || '',
    });
  };

  const handleConfirm = () => {
    const erros = validate(values, getItemSchema(values));
    setErrors(erros || {});
    if (erros) return;

    onSave({
      ...values,
      id: values.id || uuidv4(),
    });
    handleClose();
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={handleClose}
      handlerConfirm={handleConfirm}
      title={selectedItem ? 'Editar item' : 'Novo item'}
      confirmMessage="Adicionar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <OptionSelectV2
            label="Tipo da Programação"
            codigo="TIPO_PROGRAMACAO_DIARIA"
            isRequired
            onSelect={handleTipoSelect}
            value={values.tipoId}
            error={!!(errors && errors.tipoId)}
            helperText={errors && errors.tipoId ? errors.tipoId[0] || errors.tipoId : null}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <UsuarioSelectV2
            label="Ajudante/Observador"
            onSelect={(inspetorAuxiliarId, inspetorAuxiliarName) => setValues({
              ...values,
              inspetorAuxiliarId,
              inspetorAuxiliarName: inspetorAuxiliarName || '',
            })}
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorAuxiliarId}
          />
        </Grid>

        {TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === values.tipoId && (
          <>
            <Grid size={{ xs: 12, sm: 6 }}>
              <InputV2
                error={!!(errors && errors.cidadeDe)}
                helperText={errors && errors.cidadeDe ? errors.cidadeDe[0] || errors.cidadeDe : null}
                label="Cidade De"
                name="cidadeDe"
                onChange={handleChange}
                value={values.cidadeDe || ''}
                isRequired
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <InputV2
                error={!!(errors && errors.cidadePara)}
                helperText={errors && errors.cidadePara ? errors.cidadePara[0] || errors.cidadePara : null}
                label="Cidade Para"
                name="cidadePara"
                onChange={handleChange}
                value={values.cidadePara || ''}
                isRequired
              />
            </Grid>
          </>
        )}

        {TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId && (
          <Grid size={{ xs: 12 }}>
            <NsirSelectV2
              onSelect={(nsirIds, nsirCodes) => setValues({
                ...values,
                nsirIds,
                nsirCodes: nsirCodes || [],
              })}
              value={values.nsirIds}
              isRequired
              error={!!(errors && errors.nsirIds)}
              helperText={errors && errors.nsirIds ? errors.nsirIds[0] || errors.nsirIds : null}
            />
          </Grid>
        )}

        {TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === values.tipoId && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <VeiculoSelectV2
              onSelect={handleVeiculoSelect}
              value={values.veiculoId}
              isRequired
              error={!!(errors && errors.veiculoId)}
              helperText={errors && errors.veiculoId ? errors.veiculoId[0] || errors.veiculoId : null}
            />
          </Grid>
        )}

        <Grid size={{ xs: 12 }}>
          <InputV2
            error={!!(errors && errors.descricao)}
            helperText={errors && errors.descricao ? errors.descricao[0] || errors.descricao : null}
            isRequired={TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId}
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={3}
            multiline
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

ItemFormulario.propTypes = {
  open: PropTypes.bool.isRequired,
  selectedItem: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  veiculosOptions: PropTypes.array,
};

ItemFormulario.defaultProps = {
  selectedItem: null,
  veiculosOptions: [],
};

const mapStateToProps = state => ({
  veiculosOptions: getVeiculosOptions(state),
});

export default connect(mapStateToProps)(ItemFormulario);
